/**
 * Таблиця «організація × роль» — доступи користувача до організацій акаунта
 * (ч.1073: спільна для запрошення і вікна «доступи» у «Користувачах»).
 * Порожнє значення — «без доступу». Лише АКТИВНІ ролі (деактивовану бекенд
 * не видасть).
 */
import type { AccessRole } from '@/api/admin';

export default function OrgAccessTable({ orgs, roles, value, onChange }: {
  orgs: { id: string; name: string }[];
  roles: AccessRole[];
  /** organization_id → access_role_id або '' (без доступу). */
  value: Record<string, string>;
  onChange: (next: Record<string, string>) => void;
}) {
  const active = roles.filter((r) => r.status === 'ACTIVE');
  return (
    <table style={{ width: '100%', marginTop: '0.5rem' }}>
      <tbody>
        {orgs.map((o) => {
          // Уже видана роль, яку потім деактивували, — показуємо, щоб було
          // видно, що саме треба замінити (зберегти з нею бекенд не дасть).
          const current = value[o.id] ?? '';
          const stale = current && !active.some((r) => r.id === current)
            ? roles.find((r) => r.id === current) : undefined;
          return (
          <tr key={o.id}>
            <td style={{ padding: '0.3rem 0.5rem 0.3rem 0', width: '50%' }}>{o.name}</td>
            <td style={{ padding: '0.3rem 0' }}>
              <select
                aria-label={`Доступ: ${o.name}`}
                value={current}
                onChange={(e) => onChange({ ...value, [o.id]: e.target.value })}
              >
                <option value="">— Без доступу —</option>
                {stale && (
                  <option value={stale.id}>{stale.name} (деактивована — оберіть іншу)</option>
                )}
                {active.map((r) => (
                  <option key={r.id} value={r.id}>{r.name}</option>
                ))}
              </select>
            </td>
          </tr>
          );
        })}
      </tbody>
    </table>
  );
}

/** Вибране у таблиці → набір для API (без «без доступу»). */
export function toGrants(value: Record<string, string>) {
  return Object.entries(value)
    .filter(([, roleId]) => roleId !== '')
    .map(([organization_id, access_role_id]) => ({ organization_id, access_role_id }));
}
